import PageTitle from '@/mixins/page-title'
import notificationIndex from '@/mixins/notification-index'

export default {
  mixins: [
    PageTitle,
    notificationIndex,
  ],
  title () {
    return this.$t("pages.notifications.index.title")
  }
}
